const GenderIcon = ({ className, ...props }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M13.3601 7.79844C14.2517 7.66267 15.1633 7.81402 15.9632 8.2306C16.7631 8.64719 17.4097 9.30741 17.8095 10.1158C18.2093 10.9241 18.3416 11.8387 18.1873 12.7273C18.033 13.6158 17.6 14.4322 16.951 15.0584C16.302 15.6846 15.4707 16.0881 14.5772 16.2106C13.6837 16.3331 12.7744 16.1682 11.9809 15.7397C11.1873 15.3113 10.5506 14.6415 10.1629 13.8272C9.77512 13.013 9.65644 12.0965 9.82399 11.2104"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.40932 16.0095C8.55851 16.3086 7.63462 16.3292 6.77129 16.0685C5.90796 15.8078 5.14995 15.2792 4.6069 14.5592C4.06385 13.8392 3.76391 12.9651 3.75047 12.0633C3.73703 11.1616 4.01079 10.279 4.53214 9.54308C5.05349 8.80721 5.79541 8.25626 6.65059 7.96991C7.50576 7.68357 8.42986 7.67669 9.2892 7.95025C10.1486 8.22382 10.8986 8.76365 11.4309 9.49168C11.9631 10.2197 12.25 11.0982 12.25 12"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 16.5V21.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M6 19H10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M18 9L22 5M22 5V9M22 5H18"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default GenderIcon
